<template>
	<article class="image-result" :data-canvas-id="canvas.id" @click="show">
	  <div class="db db--outer">
        <div class="aspect-ratio aspect-ratio--3x4">
            <div v-lazyload class="image-result-img db contain aspect-ratio--object">
            	<div class="image-placeholder"></div>
                <img class="card-img-top image-result-img-item" :data-url="canvas.thumbnail" @load="loaded = true">
                <template v-if="previewAnnotations && canvas.annotations.length > 0 && loaded">
			    	<div v-for="annotation in canvas.annotations" :key="annotation.id" class="region" :id="'annotation' + annotation.id" v-position="{origImageWidth: canvas.width, origImageHeight: canvas.height, annotation: annotation}" />
			    </template>
            </div>
    	</div>
    	<h3 class="image-title mt-2">{{ canvas.label }}</h3>
    	<h3 class="image-detail mt-2">
    		<span data-toggle="tooltip" :title="__('translations.tooltip.number_of_tags')">
    			<i class="fas fa-tags mr-1"></i>&nbsp;<span id="tags_count">{{canvas.tags.length}}</span>
   			</span>
   			<span data-toggle="tooltip" :title="__('translations.tooltip.number_of_annotations')">
				<i class="far fa-object-ungroup ml-2 mr-1"></i>&nbsp;<span id="annotations_count">{{canvas.annotations.length}}</span>
			</span>
			<span data-toggle="tooltip" :title="__('translations.tooltip.number_of_metadata')">
				<i class="fas fa-stream ml-2 mr-1"></i>&nbsp;<span id="metadatas_count">{{canvas.metadatas_count}}</span>
			</span>
		</h3>
      </div>
    </article>
</template>

<script>
import {mapGetters} from 'vuex'
import CanvasModal from './CanvasModal'
import LazyLoadDirective from './../directives/LazyLoadDirective'
import AnnotationPositionDirective from '../directives/AnnotationPositionDirective'

export default {
	name: 'CanvasResult',
	directives: {
		lazyload: LazyLoadDirective,
		position: AnnotationPositionDirective
	},
	props: ['canvas'],
	data() {
		return {
			loaded: false
		}
	},
	computed: {
		...mapGetters([
			'previewAnnotations'
		])
	},
	methods: {
		show () {
			this.$store.dispatch('GET_CANVAS', {'id': this.canvas.id}).then((response) => {
				this.$modal.hideAll(); // To prevent from opening multiple modals
				this.$modal.show(CanvasModal, {}, {width: '100%', height: '100%'});
			});
		}
	}
}
</script>